import './vendor_header_component.scss'
